<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">APPEAL</p>
<p class="chap_line"></p>
<p class="center"><span class="big">A</span>s the days of your life turn into years that speed by even faster and your time left it does steal</p>
<p class="center">It is only on judgment day, that you finally understand that there is no higher court of appeal.</p>
<p class="center1">You will have been judged by the highest court there ever will be</p>
<p class="center">And only there will you utterly understand your choices that you made for your entire life decided whether your soul will be imprisoned or be set free.</p>
<p class="center1">It is impossible to decide what to do for every second that goes by</p>
<p class="center">And is unneeded if you embed the iron rod of God in your soul and like a compass needle keeps you on course to heaven’s gate on high.</p>
<p class="center1">All the endless glories of heaven have been promised by God the Father to be within your grasp</p>
<p class="center">If you but choose to devote and live a truly righteous life that opens the gates of Heaven’s hasp.</p>
<p class="center1">The highest glory of heaven cannot ever be entered alone</p>
<p class="center">For you must have an eternal mate at your side where love has your hearts entwined and not a single sin left to atone.</p>
<p class="center1">There is no mortal goal or thing that is more important than your salvation</p>
<p class="center1">And with the complete understanding that you chose to put your soul at risk, to prove worthy of returning to thank and honor God and Christ with love’s pure adoration.</p>
<p class="center1">As the days of your life turn into years that speed by even faster and your time left it does steal</p>
<p class="center">It is only on judgment day, that you finally understand that there is no higher court of appeal.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap010.vue?9e161c78